<link href="https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp" rel="stylesheet">

@if (isTreeData) {
    <table style="border-spacing: 0; border-width: 0; width: 100%;">
        <thead class="gridRowHeading">
            <th style="width: 25px">&nbsp;</th>
            @for (header of headers; track header; let idx = $index) {
                <th [style.width]="fieldWidth(idx, null)" [style.text-align]="header.alignment" style="vertical-align: middle; margin-right: 3px;">
                    {{header.text}}
                </th>
            }
        </thead>
    </table>
    <mat-tree #dataQueryTree [dataSource]="treeDataSource" [treeControl]="treeControl" class="dataQuery-tree" style="width: 100%">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li class="mat-tree-node">
                <button mat-icon-button disabled></button>
                <table style="width: 100%">
                    <tr>
                        @for (column of node.columns; track column; let idx = $index) {
                            <td [style.width]="fieldWidth(idx, node)" [style.text-align]="fieldAlignment(idx)">
                                @if (column.specialType === 'iostring' || column.specialType === 'iostringrequired') {
                                    <dq-iostring [value]="column.value" [size]="column.width / 10" [id]="column.name + '_' + idx" [required]="column.specialType === 'iostringrequired'"></dq-iostring>
                                }
                                @if ((!column.linkTarget || column.linkTarget === '') && column.specialType?.substring(0,8) !== 'iostring' && column.imageWidth === -1) {
                                    <span>{{column.value}}</span>
                                }
                                @if ((!column.linkTarget || column.linkTarget === '') && column.specialType?.substring(0,8) !== 'iostring' && column.imageWidth > -1) {
                                    <dq-image [src]="column.value && column.value!=='' ? imageLocation + column.value : ''" [width]="column.imageWidth"></dq-image>
                                }
                                @if (column.linkTarget && column.linkTarget !== '') {
                                    @switch (column.linkTarget) {
                                        @case ('image') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                        }
                                        @case ('imageUrl') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                        }
                                        @case ('anchor') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                        }
                                        @case ('anchorUrl') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                        }
                                        @case ('filestream/string') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                        }
                                        @case ('dataquery/string') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                        }
                                        @case ('dataquery/image') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                        }
                                        @case ('filestream/image') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                        }
                                        @case ('filestream/iframe') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                        }
                                    }
                                }
                            </td>
                        }
                    </tr>
                </table>
            </li>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when treeNodeHasChild">
            <li>
                <div class="mat-tree-node">
                    <button mat-icon-button matTreeNodeToggle>
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                    </button>
                    <table>
                        <tr>
                            @for (column of node.columns; track column; let idx = $index) {
                                <td [style.width]="fieldWidth(idx, node)" [style.text-align]="fieldAlignment(idx)">
                                    @if (column.specialType === 'iostring' || column.specialType === 'iostringrequired') {
                                        <dq-iostring [value]="column.value" [size]="column.width / 10" [id]="column.name + '_' + idx" [required]="column.specialType === 'iostringrequired'"></dq-iostring>
                                    }
                                    @if ((!column.linkTarget || column.linkTarget === '') && column.specialType?.substring(0,8) !== 'iostring' && column.imageWidth === -1) {
                                        <span>{{column.value}}</span>
                                    }
                                    @if ((!column.linkTarget || column.linkTarget === '') && column.specialType?.substring(0,8) !== 'iostring' && column.imageWidth > -1) {
                                        <dq-image [src]="column.value && column.value!=='' ? imageLocation + column.value : ''" [width]="column.imageWidth"></dq-image>
                                    }
                                    @if (column.linkTarget && column.linkTarget !== '') {
                                        @switch (column.linkTarget) {
                                            @case ('image') {
                                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                            }
                                            @case ('imageUrl') {
                                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                            }
                                            @case ('anchor') {
                                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                            }
                                            @case ('anchorUrl') {
                                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                            }
                                            @case (column.linkTarget === 'filestream/string') {
                                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                            }
                                            @case ('dataquery/string') {
                                                <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value" [allowLink]="showBusy"></dq-anchor>
                                            }
                                            @case ('dataquery/image') {
                                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                            }
                                            @case ('filestream/image') {
                                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                            }
                                            @case ('filestream/iframe') {
                                                <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)" [allowLink]="showBusy"></dq-image-link>
                                            }
                                        }
                                    }
                                </td>
                            }
                        </tr>
                    </table>
                </div>
                <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>
} @else {
    @if (rows.length > 0 || showHeader) {
        <table sortable-table (sorted)="onSorted(id, datasetId, $event)" class="resultsGrid">
            @if (showHeader) {
                <thead class="gridRowHeading">
                    @for (header of headers; track header; let index = $index) {
                        @if (header.sortable) {
                            <th [sortable-column]="index" [table-id]="datasetId" [query-id]="id" [style.width.%]="header.width > 0 ? header.width : null" [style.text-align]="header.alignment" style="padding: 3px; vertical-align: middle;">
                                {{header.text}}
                                @if (header.requiredField) {
                                    <span style="margin-left: 3px;">*</span>
                                }
                            </th>
                        } @else {
                            <th [style.width.%]="header.width > 0 ? header.width : null" [style.text-align]="header.alignment" [style.padding]="'3px'" style="padding: 3px; vertical-align: middle;">
                                {{header.text}}
                                @if (header.requiredField) {
                                    <span style="margin-left: 3px;">*</span>
                                }
                            </th>
                        }
                    }
                </thead>
            }
            @for (row of rows; track row; let isOdd = $odd; let idx = $index) {
                <tr [class.gridBandedRow]="bandedRows && isOdd">
                    @for (column of row.columns; track column; let first = $first; let last = $last; let isEven = $even) {
                        <td [style.text-align]="column.alignment"
                            [class.gridBandedColumn]="isEven && bandedColumns" [class.gridFirstColumn]="first && highlightFirst" [class.gridLastColumn]="last && highlightLast" [style.width.%]="column.width">
                            @if (column.specialType === 'image') {
                                <img [src]="'data:image/gif;base64,' + column.value" alt=""
                                    [ngStyle]="{'height': column.imageHeight > 0 ? column.imageHeight + 'px' : -1,
                                                'width': column.imageWidth > 0 ? column.imageWidth + 'px' : -1}" />
                            } @else {
                                @if (column.specialType === 'iostring' || column.specialType === 'iostringrequired') {
                                    <dq-iostring [value]="column.value" [size]="column.width / 10" [id]="column.name + '_' + idx" [required]="column.specialType === 'iostringrequired'"></dq-iostring>
                                } @else if ((!column.linkTarget || column.linkTarget === '') && column.specialType?.substring(0,8) !== 'iostring' && column.imageWidth === -1) {
                                    <span>{{column.value}}</span>
                                } @else if ((!column.linkTarget || column.linkTarget === '') && column.specialType?.substring(0,8) !== 'iostring' && column.imageWidth > -1) {
                                    <dq-image [src]="column.value && column.value!=='' ? imageLocation + column.value : ''" [width]="column.imageWidth"></dq-image>
                                } @else if (column.linkTarget && column.linkTarget !== '') {
                                    @switch (column.linkTarget) {
                                        @case ('image') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                                        }
                                        @case ('imageUrl') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" [height]="column.imageHeight" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                                        }
                                        @case ('anchor') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                                        }
                                        @case ('anchorUrl') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                                        }
                                        @case ('filestream/string') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                                        }
                                        @case ('dataquery/string') {
                                            <dq-anchor [width]="column.width" (linkSelected)="executeLink(column, idx, $event)" [value]="column.value"></dq-anchor>
                                        }
                                        @case ('dataquery/image') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                                        }
                                        @case ('filestream/image') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                                        }
                                        @case ('filestream/iframe') {
                                            <dq-image-link [src]="imageLocation + column.value" [width]="column.imageWidth" (linkSelected)="executeLink(column, idx, $event)"></dq-image-link>
                                        }
                                    }
                                }
                            }
                        </td>
                    }
                </tr>
            }
            @if (showTotal) {
                <tfoot class="gridFooter">
                    @for (footerColumn of footer.columns; track footerColumn) {
                        <td [style.text-align]="footerColumn.alignment"><span [innerHtml]="footerColumn.value"></span></td>
                    }
                </tfoot>
            }
        </table>
    }
}
@if (rows.length === 0 && showNoResultsMessage) {
    <span>{{noResultsText}}</span>
}

@if (showPartsBook) {
    <div class="partsBookContainer" style="overflow: hidden;">
        <div style="background-color: black; opacity: 50%; width: 100%; height: 100%; height: 25px;">
            <div style="float: right;">
                <button mat-button class="close-icon" (click)="showPartsBook = false; partsBookUrl = '';">
                    <mat-icon>close_icon</mat-icon>
                </button>
            </div>
        </div>
        <iframe class="fullScreenIframe" class="partsBookIframe" [src]="partsBookUrl"></iframe>
    </div>
}


